import { ApiService } from '../../../../core/services/api.service';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { downloadJPG, downloadPDF, downloadPNG, fileType } from 'src/app/utils/helpers/helpers';
import { ITimeRecord } from './types';

@Injectable({
    providedIn: 'root'
})
export class TimeRecordsService {

    constructor(private apiService: ApiService) { }

    public getNotWorkedSubcontractors(params): Observable<any> {
        return this.apiService.get(`/time_records/subcontractors/not-worked`, params);
    }

    public getNotWorkedSubcontractorsFilters(params): Observable<any> {
        return this.apiService.get(`/time_records/subcontractors/not-worked/filters`, params);
    }

    public fetchAllTimeRecords(params): Observable<any> {
        return this.apiService.get(`/time_records/getCompanyTimeRecords`, params);
    }

    public getTimeRecordsFilters(params): Observable<any> {
        return this.apiService.get(`/time_records/filters`, params);
    }

    public fetchExpenseAttachment(file: string): Observable<any> {
        return this.apiService.downloadGet(`/uploads/${file}`)
            .pipe(
                tap((response: any) => {
                    if (fileType(file) === 'pdf') {
                        downloadPDF(response);
                    } else if (fileType(file) === 'jpg' || fileType(file) === 'jpeg') {
                        downloadJPG(response);
                    } else if (fileType(file) === 'png') {
                        downloadPNG(response);
                    } else {
                        alert('Can not download file.');
                    }
                })
            );
    }

    public exportTimeRecordsToCSV(data: any): Observable<any> {
        return this.apiService.downloadGet(`/time_records/getCompanyTimeRecords`, data);
    }
    public exportNotWorkedSubcontractorsToCSV(data: any): Observable<any> {
        return this.apiService.downloadGet(`/time_records/subcontractors/not-worked/csv`, data);
    }

    public startTimeRecordBySiteManager(data: any): Observable<boolean> {
        return this.apiService.post(`/time_records/site-manager/start`, data);
    }

    public stopTimeRecordBySiteManager(data: any): Observable<boolean> {
        return this.apiService.post(`/time_records/site-manager/stop`, data);
    }

    public updateTimeRecordBySiteManager(data: any): Observable<boolean> {
        return this.apiService.post(`/time_records/site-manager/update`, data);
    }

    public removeTimeRecordBySiteManager(data: any): Observable<boolean> {
        return this.apiService.post(`/time_records/site-manager/remove`, data);
    }

    public acceptTimeRecordBySiteManager(data: any): Observable<boolean> {
        return this.apiService.post(`/time_records/site-manager/accept`, data);
    }

    public rejectTimeRecordBySiteManager(data: any): Observable<boolean> {
        return this.apiService.post(`/time_records/site-manager/reject`, data);
    }

    public updateTimeRecord(id: string, data: any): Observable<ITimeRecord> {
        return this.apiService.put(`/time_records/${id}`, data);
    }
}
